<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7931_11847)">
      <path d="M4.71558 14.0132H27.0437V15.6655C27.0437 19.8077 23.6858 23.1655 19.5437 23.1655H12.2156C8.07344 23.1655 4.71558 19.8077 4.71558 15.6655V14.0132Z"
            fill="url(#paint0_linear_7931_11847)"
      />
      <path d="M4.71558 14.0132H27.0437V15.6655C27.0437 19.8077 23.6858 23.1655 19.5437 23.1655H12.2156C8.07344 23.1655 4.71558 19.8077 4.71558 15.6655V14.0132Z"
            fill="url(#paint1_linear_7931_11847)"
      />
      <path d="M4.71558 14.0132H27.0437V15.6655C27.0437 19.8077 23.6858 23.1655 19.5437 23.1655H12.2156C8.07344 23.1655 4.71558 19.8077 4.71558 15.6655V14.0132Z"
            fill="url(#paint2_linear_7931_11847)"
      />
      <path d="M4.71558 14.0132H27.0437V15.6655C27.0437 19.8077 23.6858 23.1655 19.5437 23.1655H12.2156C8.07344 23.1655 4.71558 19.8077 4.71558 15.6655V14.0132Z"
            fill="url(#paint3_linear_7931_11847)"
      />
      <path d="M4.71558 14.0132H27.0437V15.6655C27.0437 19.8077 23.6858 23.1655 19.5437 23.1655H12.2156C8.07344 23.1655 4.71558 19.8077 4.71558 15.6655V14.0132Z"
            fill="url(#paint4_linear_7931_11847)"
      />
      <path d="M4.71558 14.0132H27.0437V15.6655C27.0437 19.8077 23.6858 23.1655 19.5437 23.1655H12.2156C8.07344 23.1655 4.71558 19.8077 4.71558 15.6655V14.0132Z"
            fill="url(#paint5_linear_7931_11847)"
      />
      <path d="M4.71558 14.0132H27.0437V15.6655C27.0437 19.8077 23.6858 23.1655 19.5437 23.1655H12.2156C8.07344 23.1655 4.71558 19.8077 4.71558 15.6655V14.0132Z"
            fill="url(#paint6_linear_7931_11847)"
      />
      <path d="M4.71558 14.0132H27.0437V15.6655C27.0437 19.8077 23.6858 23.1655 19.5437 23.1655H12.2156C8.07344 23.1655 4.71558 19.8077 4.71558 15.6655V14.0132Z"
            fill="url(#paint7_linear_7931_11847)"
      />
      <path d="M4.71558 14.0132H27.0437V15.6655C27.0437 19.8077 23.6858 23.1655 19.5437 23.1655H12.2156C8.07344 23.1655 4.71558 19.8077 4.71558 15.6655V14.0132Z"
            fill="url(#paint8_linear_7931_11847)"
      />
      <path d="M15.2889 20.3992L2.59963 13.9177C1.79912 13.5088 1.8004 12.3644 2.60183 11.9573L15.2903 5.51205C15.6606 5.32394 16.0985 5.32412 16.4687 5.51254L29.1582 11.9714C29.9593 12.3791 29.9596 13.5235 29.1588 13.9317L16.4706 20.3997C16.0994 20.5889 15.6599 20.5888 15.2889 20.3992Z"
            fill="url(#paint9_linear_7931_11847)"
      />
      <path d="M15.2889 20.3992L2.59963 13.9177C1.79912 13.5088 1.8004 12.3644 2.60183 11.9573L15.2903 5.51205C15.6606 5.32394 16.0985 5.32412 16.4687 5.51254L29.1582 11.9714C29.9593 12.3791 29.9596 13.5235 29.1588 13.9317L16.4706 20.3997C16.0994 20.5889 15.6599 20.5888 15.2889 20.3992Z"
            fill="url(#paint10_linear_7931_11847)"
      />
      <path d="M15.2889 20.3992L2.59963 13.9177C1.79912 13.5088 1.8004 12.3644 2.60183 11.9573L15.2903 5.51205C15.6606 5.32394 16.0985 5.32412 16.4687 5.51254L29.1582 11.9714C29.9593 12.3791 29.9596 13.5235 29.1588 13.9317L16.4706 20.3997C16.0994 20.5889 15.6599 20.5888 15.2889 20.3992Z"
            fill="url(#paint11_linear_7931_11847)"
      />
      <path d="M15.2889 20.3992L2.59963 13.9177C1.79912 13.5088 1.8004 12.3644 2.60183 11.9573L15.2903 5.51205C15.6606 5.32394 16.0985 5.32412 16.4687 5.51254L29.1582 11.9714C29.9593 12.3791 29.9596 13.5235 29.1588 13.9317L16.4706 20.3997C16.0994 20.5889 15.6599 20.5888 15.2889 20.3992Z"
            fill="url(#paint12_radial_7931_11847)"
            fill-opacity="0.5"
      />
      <path d="M15.2889 20.3992L2.59963 13.9177C1.79912 13.5088 1.8004 12.3644 2.60183 11.9573L15.2903 5.51205C15.6606 5.32394 16.0985 5.32412 16.4687 5.51254L29.1582 11.9714C29.9593 12.3791 29.9596 13.5235 29.1588 13.9317L16.4706 20.3997C16.0994 20.5889 15.6599 20.5888 15.2889 20.3992Z"
            fill="url(#paint13_radial_7931_11847)"
            fill-opacity="0.7"
      />
      <path d="M15.2889 20.3992L2.59963 13.9177C1.79912 13.5088 1.8004 12.3644 2.60183 11.9573L15.2903 5.51205C15.6606 5.32394 16.0985 5.32412 16.4687 5.51254L29.1582 11.9714C29.9593 12.3791 29.9596 13.5235 29.1588 13.9317L16.4706 20.3997C16.0994 20.5889 15.6599 20.5888 15.2889 20.3992Z"
            fill="url(#paint14_radial_7931_11847)"
            fill-opacity="0.4"
      />
      <path d="M15.2889 20.3992L2.59963 13.9177C1.79912 13.5088 1.8004 12.3644 2.60183 11.9573L15.2903 5.51205C15.6606 5.32394 16.0985 5.32412 16.4687 5.51254L29.1582 11.9714C29.9593 12.3791 29.9596 13.5235 29.1588 13.9317L16.4706 20.3997C16.0994 20.5889 15.6599 20.5888 15.2889 20.3992Z"
            fill="url(#paint15_linear_7931_11847)"
            fill-opacity="0.7"
      />
      <path d="M15.2889 20.3992L2.59963 13.9177C1.79912 13.5088 1.8004 12.3644 2.60183 11.9573L15.2903 5.51205C15.6606 5.32394 16.0985 5.32412 16.4687 5.51254L29.1582 11.9714C29.9593 12.3791 29.9596 13.5235 29.1588 13.9317L16.4706 20.3997C16.0994 20.5889 15.6599 20.5888 15.2889 20.3992Z"
            fill="url(#paint16_linear_7931_11847)"
            fill-opacity="0.9"
      />
      <path d="M15.2889 20.3992L2.59963 13.9177C1.79912 13.5088 1.8004 12.3644 2.60183 11.9573L15.2903 5.51205C15.6606 5.32394 16.0985 5.32412 16.4687 5.51254L29.1582 11.9714C29.9593 12.3791 29.9596 13.5235 29.1588 13.9317L16.4706 20.3997C16.0994 20.5889 15.6599 20.5888 15.2889 20.3992Z"
            fill="url(#paint17_radial_7931_11847)"
            fill-opacity="0.8"
      />
      <path d="M15.2889 20.3992L2.59963 13.9177C1.79912 13.5088 1.8004 12.3644 2.60183 11.9573L15.2903 5.51205C15.6606 5.32394 16.0985 5.32412 16.4687 5.51254L29.1582 11.9714C29.9593 12.3791 29.9596 13.5235 29.1588 13.9317L16.4706 20.3997C16.0994 20.5889 15.6599 20.5888 15.2889 20.3992Z"
            fill="url(#paint18_radial_7931_11847)"
            fill-opacity="0.4"
      />
      <path d="M15.2889 20.3992L2.59963 13.9177C1.79912 13.5088 1.8004 12.3644 2.60183 11.9573L15.2903 5.51205C15.6606 5.32394 16.0985 5.32412 16.4687 5.51254L29.1582 11.9714C29.9593 12.3791 29.9596 13.5235 29.1588 13.9317L16.4706 20.3997C16.0994 20.5889 15.6599 20.5888 15.2889 20.3992Z"
            fill="url(#paint19_radial_7931_11847)"
            fill-opacity="0.2"
      />
      <path d="M15.2889 20.3992L2.59963 13.9177C1.79912 13.5088 1.8004 12.3644 2.60183 11.9573L15.2903 5.51205C15.6606 5.32394 16.0985 5.32412 16.4687 5.51254L29.1582 11.9714C29.9593 12.3791 29.9596 13.5235 29.1588 13.9317L16.4706 20.3997C16.0994 20.5889 15.6599 20.5888 15.2889 20.3992Z"
            fill="url(#paint20_radial_7931_11847)"
            fill-opacity="0.8"
      />
      <path d="M15.2889 20.3992L2.59963 13.9177C1.79912 13.5088 1.8004 12.3644 2.60183 11.9573L15.2903 5.51205C15.6606 5.32394 16.0985 5.32412 16.4687 5.51254L29.1582 11.9714C29.9593 12.3791 29.9596 13.5235 29.1588 13.9317L16.4706 20.3997C16.0994 20.5889 15.6599 20.5888 15.2889 20.3992Z"
            fill="url(#paint21_radial_7931_11847)"
            fill-opacity="0.3"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.4135 11.1683C15.5954 10.8116 16.032 10.6698 16.3887 10.8517L22.1026 13.7654C23.1826 14.3162 23.8625 15.4261 23.8625 16.6384V22.482C23.8625 22.8824 23.5379 23.207 23.1375 23.207C22.7371 23.207 22.4125 22.8824 22.4125 22.482V16.6384C22.4125 15.9712 22.0383 15.3603 21.4439 15.0572L15.73 12.1435C15.3733 11.9616 15.2316 11.525 15.4135 11.1683Z"
            fill="url(#paint22_linear_7931_11847)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.4135 11.1683C15.5954 10.8116 16.032 10.6698 16.3887 10.8517L22.1026 13.7654C23.1826 14.3162 23.8625 15.4261 23.8625 16.6384V22.482C23.8625 22.8824 23.5379 23.207 23.1375 23.207C22.7371 23.207 22.4125 22.8824 22.4125 22.482V16.6384C22.4125 15.9712 22.0383 15.3603 21.4439 15.0572L15.73 12.1435C15.3733 11.9616 15.2316 11.525 15.4135 11.1683Z"
            fill="url(#paint23_radial_7931_11847)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.4135 11.1683C15.5954 10.8116 16.032 10.6698 16.3887 10.8517L22.1026 13.7654C23.1826 14.3162 23.8625 15.4261 23.8625 16.6384V22.482C23.8625 22.8824 23.5379 23.207 23.1375 23.207C22.7371 23.207 22.4125 22.8824 22.4125 22.482V16.6384C22.4125 15.9712 22.0383 15.3603 21.4439 15.0572L15.73 12.1435C15.3733 11.9616 15.2316 11.525 15.4135 11.1683Z"
            fill="url(#paint24_linear_7931_11847)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.4135 11.1683C15.5954 10.8116 16.032 10.6698 16.3887 10.8517L22.1026 13.7654C23.1826 14.3162 23.8625 15.4261 23.8625 16.6384V22.482C23.8625 22.8824 23.5379 23.207 23.1375 23.207C22.7371 23.207 22.4125 22.8824 22.4125 22.482V16.6384C22.4125 15.9712 22.0383 15.3603 21.4439 15.0572L15.73 12.1435C15.3733 11.9616 15.2316 11.525 15.4135 11.1683Z"
            fill="url(#paint25_linear_7931_11847)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.4135 11.1683C15.5954 10.8116 16.032 10.6698 16.3887 10.8517L22.1026 13.7654C23.1826 14.3162 23.8625 15.4261 23.8625 16.6384V22.482C23.8625 22.8824 23.5379 23.207 23.1375 23.207C22.7371 23.207 22.4125 22.8824 22.4125 22.482V16.6384C22.4125 15.9712 22.0383 15.3603 21.4439 15.0572L15.73 12.1435C15.3733 11.9616 15.2316 11.525 15.4135 11.1683Z"
            fill="url(#paint26_radial_7931_11847)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.4135 11.1683C15.5954 10.8116 16.032 10.6698 16.3887 10.8517L22.1026 13.7654C23.1826 14.3162 23.8625 15.4261 23.8625 16.6384V22.482C23.8625 22.8824 23.5379 23.207 23.1375 23.207C22.7371 23.207 22.4125 22.8824 22.4125 22.482V16.6384C22.4125 15.9712 22.0383 15.3603 21.4439 15.0572L15.73 12.1435C15.3733 11.9616 15.2316 11.525 15.4135 11.1683Z"
            fill="url(#paint27_radial_7931_11847)"
            fill-opacity="0.5"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.4135 11.1683C15.5954 10.8116 16.032 10.6698 16.3887 10.8517L22.1026 13.7654C23.1826 14.3162 23.8625 15.4261 23.8625 16.6384V22.482C23.8625 22.8824 23.5379 23.207 23.1375 23.207C22.7371 23.207 22.4125 22.8824 22.4125 22.482V16.6384C22.4125 15.9712 22.0383 15.3603 21.4439 15.0572L15.73 12.1435C15.3733 11.9616 15.2316 11.525 15.4135 11.1683Z"
            fill="url(#paint28_radial_7931_11847)"
            fill-opacity="0.4"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.4135 11.1683C15.5954 10.8116 16.032 10.6698 16.3887 10.8517L22.1026 13.7654C23.1826 14.3162 23.8625 15.4261 23.8625 16.6384V22.482C23.8625 22.8824 23.5379 23.207 23.1375 23.207C22.7371 23.207 22.4125 22.8824 22.4125 22.482V16.6384C22.4125 15.9712 22.0383 15.3603 21.4439 15.0572L15.73 12.1435C15.3733 11.9616 15.2316 11.525 15.4135 11.1683Z"
            fill="url(#paint29_radial_7931_11847)"
            fill-opacity="0.7"
      />
      <path d="M22.4187 22.4741C21.7703 22.7397 21.4695 23.2971 21.4695 23.9038C21.4695 24.825 22.2163 25.5718 23.1375 25.5718C24.0586 25.5718 24.8054 24.825 24.8054 23.9038C24.8054 23.2971 24.45 22.7554 23.864 22.4741H22.4187Z"
            fill="url(#paint30_radial_7931_11847)"
      />
      <path d="M22.4187 22.4741C21.7703 22.7397 21.4695 23.2971 21.4695 23.9038C21.4695 24.825 22.2163 25.5718 23.1375 25.5718C24.0586 25.5718 24.8054 24.825 24.8054 23.9038C24.8054 23.2971 24.45 22.7554 23.864 22.4741H22.4187Z"
            fill="url(#paint31_radial_7931_11847)"
      />
      <path d="M22.4187 22.4741C21.7703 22.7397 21.4695 23.2971 21.4695 23.9038C21.4695 24.825 22.2163 25.5718 23.1375 25.5718C24.0586 25.5718 24.8054 24.825 24.8054 23.9038C24.8054 23.2971 24.45 22.7554 23.864 22.4741H22.4187Z"
            fill="url(#paint32_radial_7931_11847)"
      />
      <path d="M21.2256 27.6467L21.864 24.9976H24.3914L25.0425 27.6239C25.0991 27.8087 25.1296 28.0051 25.1296 28.2085C25.1296 29.3088 24.2377 30.2007 23.1375 30.2007C22.0372 30.2007 21.1453 29.3088 21.1453 28.2085C21.1453 28.0134 21.1733 27.8248 21.2256 27.6467Z"
            fill="#FF9D4E"
      />
      <path d="M21.2256 27.6467L21.864 24.9976H24.3914L25.0425 27.6239C25.0991 27.8087 25.1296 28.0051 25.1296 28.2085C25.1296 29.3088 24.2377 30.2007 23.1375 30.2007C22.0372 30.2007 21.1453 29.3088 21.1453 28.2085C21.1453 28.0134 21.1733 27.8248 21.2256 27.6467Z"
            fill="url(#paint33_linear_7931_11847)"
      />
      <path d="M21.2256 27.6467L21.864 24.9976H24.3914L25.0425 27.6239C25.0991 27.8087 25.1296 28.0051 25.1296 28.2085C25.1296 29.3088 24.2377 30.2007 23.1375 30.2007C22.0372 30.2007 21.1453 29.3088 21.1453 28.2085C21.1453 28.0134 21.1733 27.8248 21.2256 27.6467Z"
            fill="url(#paint34_radial_7931_11847)"
      />
      <path d="M21.2256 27.6467L21.864 24.9976H24.3914L25.0425 27.6239C25.0991 27.8087 25.1296 28.0051 25.1296 28.2085C25.1296 29.3088 24.2377 30.2007 23.1375 30.2007C22.0372 30.2007 21.1453 29.3088 21.1453 28.2085C21.1453 28.0134 21.1733 27.8248 21.2256 27.6467Z"
            fill="url(#paint35_radial_7931_11847)"
      />
    </g>
    <defs>
      <linearGradient id="paint0_linear_7931_11847"
                      x1="25.95"
                      y1="18.5894"
                      x2="5.94995"
                      y2="18.5894"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#68518B" />
        <stop stop-color="#68518B" />
        <stop offset="0.44375"
              stop-color="#503678"
        />
        <stop offset="0.909375"
              stop-color="#35254E"
        />
      </linearGradient>
      <linearGradient id="paint1_linear_7931_11847"
                      x1="17.2368"
                      y1="23.5142"
                      x2="17.2368"
                      y2="22.1623"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.213939"
              stop-color="#8265AE"
        />
        <stop offset="0.627716"
              stop-color="#8265AE"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint2_linear_7931_11847"
                      x1="22.4839"
                      y1="23.1655"
                      x2="22.2358"
                      y2="21.7233"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.213939"
              stop-color="#8265AE"
        />
        <stop offset="0.669614"
              stop-color="#8265AE"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint3_linear_7931_11847"
                      x1="23.3427"
                      y1="22.9829"
                      x2="22.2358"
                      y2="21.5897"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.213939"
              stop-color="#8265AE"
        />
        <stop offset="0.669614"
              stop-color="#8265AE"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint4_linear_7931_11847"
                      x1="10.2082"
                      y1="23.5823"
                      x2="10.6979"
                      y2="21.4865"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.287504"
              stop-color="#8265AE"
        />
        <stop offset="0.510172"
              stop-color="#8265AE"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint5_linear_7931_11847"
                      x1="8.77467"
                      y1="23.1655"
                      x2="9.88047"
                      y2="21.5181"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.213939"
              stop-color="#8265AE"
        />
        <stop offset="0.494627"
              stop-color="#8265AE"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint6_linear_7931_11847"
                      x1="24.7764"
                      y1="22.4612"
                      x2="23.0445"
                      y2="21.2332"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.213939"
              stop-color="#8265AE"
        />
        <stop offset="0.565866"
              stop-color="#8265AE"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint7_linear_7931_11847"
                      x1="27.0437"
                      y1="18.7475"
                      x2="24.8631"
                      y2="17.9219"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.213939"
              stop-color="#8265AE"
        />
        <stop offset="0.457665"
              stop-color="#8265AE"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint8_linear_7931_11847"
                      x1="27.5337"
                      y1="17.7802"
                      x2="25.1862"
                      y2="17.6063"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.213939"
              stop-color="#8265AE"
        />
        <stop offset="0.457665"
              stop-color="#8265AE"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint9_linear_7931_11847"
                      x1="28.1921"
                      y1="12.9563"
                      x2="7.26245"
                      y2="12.9563"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#655676" />
        <stop offset="1"
              stop-color="#2D2635"
        />
      </linearGradient>
      <linearGradient id="paint10_linear_7931_11847"
                      x1="23.5984"
                      y1="16.8885"
                      x2="22.6549"
                      y2="15.0843"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0945294"
              stop-color="#5E417D"
        />
        <stop offset="0.305542"
              stop-color="#5E417D"
              stop-opacity="0.55"
        />
        <stop offset="0.63958"
              stop-color="#FFFFFF"
              stop-opacity="0.21"
        />
        <stop offset="1"
              stop-color="#5E417D"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint11_linear_7931_11847"
                      x1="8.81989"
                      y1="17.474"
                      x2="10.5624"
                      y2="13.9762"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0602626"
              stop-color="#553578"
              stop-opacity="0.92"
        />
        <stop offset="0.190937"
              stop-color="#271D34"
              stop-opacity="0.72"
        />
        <stop offset="0.289017"
              stop-color="#281D38"
              stop-opacity="0.78"
        />
        <stop offset="0.477925"
              stop-color="#281D38"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint12_radial_7931_11847"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(15.739 19.6309) rotate(177.31) scale(1.50728 1.25984)"
      >
        <stop stop-color="#291E39" />
        <stop offset="0.592241"
              stop-color="#2B213A"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint13_radial_7931_11847"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(16.1641 20.5415) rotate(62.0641) scale(0.988853 2.83059)"
      >
        <stop offset="0.472951"
              stop-color="#5D417A"
              stop-opacity="0.99"
        />
        <stop offset="1"
              stop-color="#5D417B"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint14_radial_7931_11847"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(16.0036 20.8647) rotate(74.1688) scale(0.953767 4.57935)"
      >
        <stop offset="0.472951"
              stop-color="#704999"
              stop-opacity="0.99"
        />
        <stop offset="1"
              stop-color="#704999"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint15_linear_7931_11847"
                      x1="25.4778"
                      y1="9.91221"
                      x2="24.9238"
                      y2="11.0102"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0945294"
              stop-color="#5E417D"
        />
        <stop offset="0.622903"
              stop-color="#5E417D"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint16_linear_7931_11847"
                      x1="29.7593"
                      y1="12.6978"
                      x2="28.4763"
                      y2="13.1447"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.220071"
              stop-color="#5E417D"
        />
        <stop offset="0.547178"
              stop-color="#5E417D"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint17_radial_7931_11847"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(18.4196 13.3823) rotate(111.317) scale(1.36074 4.92266)"
      >
        <stop offset="0.643211"
              stop-color="#2F243E"
              stop-opacity="0.82"
        />
        <stop offset="1"
              stop-color="#443149"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint18_radial_7931_11847"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(19.1532 13.6202) rotate(123.659) scale(1.24816 5.66184)"
      >
        <stop offset="0.535842"
              stop-color="#2F243E"
              stop-opacity="0.82"
        />
        <stop offset="0.698285"
              stop-color="#2F243E"
              stop-opacity="0.56"
        />
        <stop offset="1"
              stop-color="#443149"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint19_radial_7931_11847"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(19.1252 13.9035) rotate(122.793) scale(1.27613 6.74552)"
      >
        <stop offset="0.535842"
              stop-color="#2F243E"
              stop-opacity="0.82"
        />
        <stop offset="0.802784"
              stop-color="#2F243E"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint20_radial_7931_11847"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(22.3051 16.5781) rotate(168.236) scale(1.25816 4.37163)"
      >
        <stop offset="0.0687201"
              stop-color="#463459"
        />
        <stop offset="0.376541"
              stop-color="#463459"
              stop-opacity="0.44"
        />
        <stop offset="0.500285"
              stop-color="#463459"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint21_radial_7931_11847"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(22.3685 16.7936) rotate(178.187) scale(1.29577 1.93485)"
      >
        <stop offset="0.525084"
              stop-color="#463459"
              stop-opacity="0.65"
        />
        <stop offset="0.767696"
              stop-color="#463459"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint22_linear_7931_11847"
                      x1="17.2625"
                      y1="11.2632"
                      x2="23.3875"
                      y2="23.207"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D3A543" />
        <stop offset="1"
              stop-color="#FFBA62"
        />
      </linearGradient>
      <radialGradient id="paint23_radial_7931_11847"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(15.6842 10.4633) rotate(26.9588) scale(3.89487 2.42803)"
      >
        <stop stop-color="#D0A745" />
        <stop offset="1"
              stop-color="#D0A745"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint24_linear_7931_11847"
                      x1="24.2735"
                      y1="18.2146"
                      x2="23.0764"
                      y2="18.3044"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFD574" />
        <stop offset="1"
              stop-color="#FFD574"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint25_linear_7931_11847"
                      x1="22.0887"
                      y1="13.3214"
                      x2="21.6249"
                      y2="14.2043"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFD574" />
        <stop offset="1"
              stop-color="#FFD574"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint26_radial_7931_11847"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(22.2811 21.753) rotate(-90.2535) scale(6.14948 0.901051)"
      >
        <stop stop-color="#A84A17" />
        <stop offset="1"
              stop-color="#D07442"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint27_radial_7931_11847"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(22.4459 18.1105) rotate(-90.4692) scale(3.51382 0.719445)"
      >
        <stop stop-color="#A84A17" />
        <stop offset="1"
              stop-color="#D07442"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint28_radial_7931_11847"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(17.8442 13.2634) rotate(25.0263) scale(6.25403 0.294605)"
      >
        <stop offset="0.140165"
              stop-color="#A84A17"
        />
        <stop offset="0.640759"
              stop-color="#D07442"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint29_radial_7931_11847"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(19.6876 16.9897) rotate(-14.8987) scale(4.12794 3.44837)"
      >
        <stop offset="0.60255"
              stop-color="#A84A17"
        />
        <stop offset="0.798021"
              stop-color="#D07442"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint30_radial_7931_11847"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(24.1538 23.3921) rotate(137.337) scale(2.07561 2.23528)"
      >
        <stop stop-color="#FFCC6C" />
        <stop offset="1"
              stop-color="#F49041"
        />
      </radialGradient>
      <radialGradient id="paint31_radial_7931_11847"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(24.4403 24.2893) rotate(-157.449) scale(3.7252 2.99627)"
      >
        <stop offset="0.6"
              stop-color="#B25D41"
              stop-opacity="0"
        />
        <stop offset="0.910505"
              stop-color="#B25D41"
        />
      </radialGradient>
      <radialGradient id="paint32_radial_7931_11847"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(21.8454 25.0765) rotate(-8.85796) scale(2.27208 1.10448)"
      >
        <stop stop-color="#FD805E" />
        <stop offset="1"
              stop-color="#FD805E"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint33_linear_7931_11847"
                      x1="21.3498"
                      y1="27.5991"
                      x2="22.8659"
                      y2="27.8463"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D17047" />
        <stop offset="1"
              stop-color="#D17047"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint34_radial_7931_11847"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(24.0904 24.7266) rotate(90) scale(4.37335 1.34116)"
      >
        <stop offset="0.566667"
              stop-color="#FFBC6E"
        />
        <stop offset="1"
              stop-color="#FFBC6E"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint35_radial_7931_11847"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(22.3994 30.2007) rotate(-77.3666) scale(2.66611 3.07857)"
      >
        <stop offset="0.165333"
              stop-color="#FF697E"
        />
        <stop offset="1"
              stop-color="#FF697E"
              stop-opacity="0"
        />
      </radialGradient>
      <clipPath id="clip0_7931_11847">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>